
//import Config from '../config/appConstants';
import Config, { Process as process } from '../config/appConstants';
import { createAPIRequest } from "../services/api/endPoint";
import CryptoJS from 'crypto-js';
import aesjs from 'aes-js';
import sanitizeHtml from 'sanitize-html';
import { store } from '../redux';
import Swal from 'sweetalert2';
import translateLabel from "./shared/translation";
import { logErrorAPI } from './../services/api/helper'
import axios from 'axios';
import { NoRecFoundAlert, WarningAlert } from './shared/alerts/common-sweet-alerts';
// console.log("proce", process)

const getPdfPath = (filename, isLangFoler, lang) => {

    if (isLangFoler) {
        return `${process.env.REACT_APP_TEMPLATE_PATH}assets/docs/${lang === Config.LANG.EN ? "English/" : "Arabic/"}${filename}`
    }

    return `${process.env.REACT_APP_TEMPLATE_PATH}assets/docs/${filename}`
}

const getActionHelperCode =(code)=> {
    var key = CryptoJS.enc.Hex.parse("000102030405060708090a0b0c0d0e0f");
    var iv = CryptoJS.enc.Hex.parse("101112131415161718191a1b1c1d1e1f");

    var decrypted =  CryptoJS.AES.decrypt(code, key, { iv:iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7 
    })
    return decrypted.toString(CryptoJS.enc.Utf8)
}

const getEncryptActionCode =(code)=> {
    var key = CryptoJS.enc.Hex.parse("000102030405060708090a0b0c0d0e0f");
    var iv = CryptoJS.enc.Hex.parse("101112131415161718191a1b1c1d1e1f");

    var encryoted =  CryptoJS.AES.encrypt(code, key, { iv:iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7 
    })
    return encryoted.toString();
}

const logoutAccordingToRole = (props, userType = "proxy") => {

    if (userType === "proxy") {
        // Proxy logout     
        const organizationDetails = store.getState().organizationDetails.OrganizationUserDetails
        // const pki_details = store.getState().organizationDetails.pki_details

        // delete pki_details.OrgUserValidator
        // delete pki_details.proxyUserLoginInfo

        props.setPKIDetails({
            ...store.getState().pki_details,
            ...{
                pkiSimCardDetails: {
                    IDTypeID: organizationDetails.OrganizationUserIDTypeID,
                    NationalityID: organizationDetails.OrganizationUserNationalityID
                }
            }
        }); //, ...{ userType: store.getState().createdUserTypeID
        props.setResourceDetails(store.getState().organizationDetails.resourceDetails)
        props.setApplicantUserType(store.getState().orgUserValidator.OrgLogUserType)
        props.setOrgUserValidator({})
        // props.setOrganizationDetails({ OrganizationUserDetails: organizationDetails })
        props.setProxyUserDetails({})

        props.history.push("/postoffice/signin")
    } else {
        if (props.proxyUserDetails && props.proxyUserDetails.ProxyLoginDetails) {
            // individual after citizen as proxy logout 
            props.setProxyUserDetails({})
            // props.history.push('/proxy/search-applicant')
            props.history.push('/delegation/search-register-applicant');

        } else {
            props.setResourceDetails(store.getState().organizationDetails.resourceDetails)
            props.setApplicantUserType(store.getState().orgUserValidator.OrgLogUserType)
            props.setOrgUserValidator({})
            props.history.push('/postoffice/signin')
        }
    }
}

const getAllDataFromIncludedKeys = (dataRow, data) => {
    if (dataRow.includeKeys.length > 0) {
        let parObj = {}

       //console.log("data details", dataRow.includeKeys)
        dataRow.includeKeys.map(itemR => {
            if (typeof (itemR) === "object") {
                let detail = {}
                if (itemR.apiParam && data[dataRow.key][itemR.key]) {
                    if(itemR.includeKeys.length > 0){
                        itemR.includeKeys.map(item => {
                            detail[item] = data[dataRow.key][itemR.key][item]
                           // console.log("detail", itemR.apiParam, dataRow.key,'---------------',itemR.key,'-----', item)
                            return item
                        })
                    }else{
                        detail[itemR.key] = data[dataRow.key][itemR.key]
                    }
                    detail["apiIdentifier"] = itemR.apiParam
                } 
                //console.log("detail@@@@", dataRow.key, "^^^^^",itemR.key, data, '---------------',data[dataRow.key]["OrganizationDetails"],'-----', itemR.key + "****OrganizationDetails")
                      
                parObj[itemR.key] = detail && Object.keys(detail).length > 0 ? detail : data[dataRow.key][itemR.key]
            }else{
                parObj[itemR] = data[dataRow.key][itemR]
                parObj["apiIdentifier"] = dataRow.apiParam
            }
            return itemR
        })
        return { [dataRow.key]: parObj } //{ [dataRow.key]: data[dataRow.key]}
    }
}


const getFilteredData = (dataRow, data) => {
    // console.log("loginInpuCopyloginInpuCopyloginInpuCopy",data[dataRow.key],dataRow.key )
    if (!dataRow.isRetrivable) {
        if( dataRow.includeKeys.length > 0){
            return getAllDataFromIncludedKeys(dataRow, data) //{ [dataRow.key]: data[dataRow.key]}
        }else{
            return {[dataRow.key]: data[dataRow.key]}
        }
    } else {
        return getAllDataFromIncludedKeys(dataRow, data)
    }
    // return false
}


const logoutPostOfficeVisitor = (props, isInvolvedPartyFailded) => {

    // PostOffice Visistor logout     
    // const organizationDetails = store.getState().organizationDetails.OrganizationUserDetails
    if(!isInvolvedPartyFailded) {
        const pki_details = store.getState().organizationDetails.pki_details
        delete pki_details.OrgUserValidator
        props.setPKIDetails({ ...pki_details, ...{ userType: store.getState().createdUserTypeID } });
    } else {
        props.setPKIDetails({ ...store.getState().pki_details, ...{ userType: store.getState().createdUserTypeID } });
    }
    
    props.setResourceDetails(store.getState().organizationDetails.resourceDetails)
    props.setApplicantUserType(store.getState().orgUserValidator.OrgLogUserType)
    // props.setOrganizationDetails({ OrganizationUserDetails: organizationDetails })
    props.history.push("/postoffice/signin")
}


const redirectWithReductData = async (url, props = "", baseUrl = "") => {
    // return;
    if(url === "/work-item/list") {
        props.history.push(url)
    } else {
    // let paramsInclude = ["pki_details", "proxyUserDetails", "applicantUserType", "applicantUserTypeData", "applicantUserID", "resourceDetails", "organizationDetails", "orgUserValidator", "lang", "theme", "font", 'createdUserTypeID', "applicableService", "applicableSubService", "selectedService", "applicantUserTypeData", "profileUserDetails"]
    let paramsIncludeData = [{ key: "pki_details", isRetrivable: false, apiParam: "", includeKeys: [] },
    {
        key: "proxyUserDetails", isRetrivable: false, apiParam: "", includeKeys: [
            { key: "ProxyLoginDetails", isRetrivable: true, apiParam: "proxy", includeKeys: ["ApplicantCRN","ApplicantID","ProxyNumber","ProxyIssuerID","InvolvedPartiesSubTypeEnglish","InvolvedPartyID","IsSpecific","NameChangeFlag","ProxyFullName","ProxyID","ProxyUniqueID","ApplicantUserType"] }, //"ProxyID", "ProxyNumber", "InvolvedPartySubTypeID","InvolvedPartyTypeID","NationalityID" 
            { key: "isProxySearchLoaded", isRetrivable: false, apiParam: "" }
        ]
    },
    { key: "applicantUserType", isRetrivable: false, apiParam: "", includeKeys: [] },
    { key: "applicantUserTypeData", isRetrivable: false, apiParam: "", includeKeys: [] },
    { key: "applicantUserID", isRetrivable: false, apiParam: "", includeKeys: [] },
    { key: "resourceDetails", isRetrivable: true, apiParam: "resourceDetails", includeKeys: ["InvolvedPartyID","InvolvedPartiesSubTypeEnglish","InvolvedPartiesSubTypeArabic","InvolvedPartySubTypeID","InvolvedPartyTypeID","NationalityID","IDTypeID"] },
    {
        key: "organizationDetails", isRetrivable: false, apiParam: "", includeKeys: [
            { key: "OrganizationUserDetails", isRetrivable: true, apiParam: "orgRes", includeKeys: ["OrganizationCRNumber", "OrganizationSubTypeID", "OrganizationUserCRN","OrganizationSubTypeEnglish","OrganizationUserIDTypeID","OrganizationUserNationalityID"] },
            { key: "OrganizatonDetails", isRetrivable: false, apiParam: "", includeKeys: ["OrganizationCRNumber", "OrganizationID", "OrganizationName", "OrganizationNameEnglish", "OrganizationSubTypeArabic","OrganizationSubTypeEnglish","OrganizationSubTypeID", "label", "value"] },
            { key: "resourceDetails", isRetrivable: true, apiParam: "resourceDetails", includeKeys: ["InvolvedPartyID","IDTypeID","InvolvedPartiesSubTypeEnglish","InvolvedPartySubTypeID","InvolvedPartyTypeID","NationalityID","InvolvedPartiesSubTypeArabic"] },
            { key: "orgUserType", isRetrivable: false, apiParam: "", includeKeys: [] }
        ]
    },
    { key: "orgUserValidator", isRetrivable: false, apiParam: "", includeKeys: [] },
    { key: "lang", isRetrivable: false, apiParam: "", includeKeys: [] },
    { key: "theme", isRetrivable: false, apiParam: "", includeKeys: [] },
    { key: "font", isRetrivable: false, apiParam: "", includeKeys: [] },
    { key: 'createdUserTypeID', isRetrivable: false, apiParam: "", includeKeys: [] },
    { key: "applicableService", isRetrivable: false, apiParam: "", includeKeys: [] },
    { key: "applicableSubService", isRetrivable: false, apiParam: "", includeKeys: [] },
    { key: "selectedService", isRetrivable: false, apiParam: "", includeKeys: [] },
    { key: "applicantUserTypeData", isRetrivable: false, apiParam: "", includeKeys: [] },
    { key: "profileUserDetails", isRetrivable: false, apiParam: "", includeKeys: [] },
    { key: "isdUser", isRetrivable: true, apiParam: "", includeKeys: ["isdUser"] }
    ]

    let params = store.getState();
    // let loginInput = { "routes": url };
    let loginInpuCopy = { "routes": url };
    // Object.keys(params).forEach(function (key) {
    //     if (paramsInclude.includes(key) && Object.keys(params[key]).length) {
    //         loginInput = { ...loginInput, [key]: typeof params[key] === "object" ? { ...params[key] } : params[key] };
    //     }
    // })

    paramsIncludeData.forEach(function (data, index) {
        if (Object.keys(params[data.key]).length) {
            const retrievedData = getFilteredData(data, params)
            // console.log("retrievedDa",retrievedData)
            if (retrievedData) {
                loginInpuCopy = { ...loginInpuCopy, ...retrievedData }
            }
            // loginInpuCopy = { ...loginInpuCopy, [data.key]: typeof params[data.key] === "object" ? { ...params[data.key] } : params[data.key] };
        }
    });

    let Base_Url;
    // let Base_Url = process.env.REACT_APP_WEB_HOST_REAL_ESTATE //real-estate //slug

        // if (baseUrl) {
        //     Base_Url = baseUrl //real-estate //slug
        // }
        if (url.includes("planning-survey")) {
            Base_Url = process.env.REACT_APP_WEB_HOST_PSN + "domain-redirect/";
            //Base_Url = "http://localhost:3003/"; //process.env.REACT_APP_WEB_HOST_PSN;
            //console.log("base", url, Base_Url, process.env)
        } else if (url.includes("real-estate")) {
            Base_Url = process.env.REACT_APP_WEB_HOST_REAL_ESTATE + "domain-redirect/";
        } else if (url.includes("land")) {
            Base_Url = process.env.REACT_APP_WEB_HOST_LAND + "domain-redirect/";
        } else if (url.includes("re-dev")) {
            Base_Url = process.env.REACT_APP_WEB_HOST_RD + "domain-redirect/";
        } else if (url === "/e-service/social-housing") {
            Base_Url = process.env.REACT_APP_WEB_HOST_SOCIAL_HOUSING + "domain-redirect/";
        } else if (url.includes('/e-service/engineering-consultancy')) {
            Base_Url = process.env.REACT_APP_WEB_HOST_SOCIAL_HOUSING + "domain-redirect/";
        } else {
            Base_Url = process.env.REACT_APP_WEB_HOST_REAL_ESTATE + "domain-redirect/";
        }
        // Base_Url = await getBaseUrl(url);

        // return false;
        // let path = Base_Url + "domain-redirect/" + btoa(encodeURIComponent(JSON.stringify(loginInput)))
        let path = Base_Url + btoa(encodeURIComponent(JSON.stringify(loginInpuCopy)))
        // let path = Base_Url + "re-redirect/" + btoa(encodeURIComponent(JSON.stringify(loginInpuCopy)))
        window.location = path
    }
}

// const getBaseUrl = async (url) => {
//    console.log("getBaseUrl",url.includes("planning-survey"));
//    let base_url ="";
//    switch(url){
//       case url.includes("planning-survey") : 
//         console.log("111111111111111111111",process.env.REACT_APP_WEB_HOST_PSN)
//         base_url = process.env.REACT_APP_WEB_HOST_PSN
//       break
//       case url.includes("real-estate") : 
//       console.log("22222222222222222222222",process.env.REACT_APP_WEB_HOST_REAL_ESTATE)

//       base_url = process.env.REACT_APP_WEB_HOST_REAL_ESTATE
//       break
//       case url.includes("land") : 
//       console.log("33333333333",process.env.REACT_APP_WEB_HOST_REAL_ESTATE)
//       base_url = process.env.REACT_APP_WEB_HOST_REAL_ESTATE
//       break
//       default: 
//       console.log("4444444444444444")
//       base_url = process.env.REACT_APP_WEB_HOST_REAL_ESTATE
//    }
//    return base_url; 
//     // if(url && url.includes("planning-survey")){
//     //     Base_Url = process.env.REACT_APP_WEB_HOST_PSN;
//     // }
// }

const logoutFlushStore = (props) => {
    props.setPKIDetails({});
    props.setResourceDetails({})
    props.setApplicantUserType({})
    props.setOrgUserValidator({})
    props.setOrganizationDetails({})
    props.setProxyUserDetails({})
    if(props.hasOwnProperty('setAdminDetails')){
        props.setAdminDetails({})
    }
    if(props.hasOwnProperty('setRegisterCompanyDetails')){
        props.setRegisterCompanyDetails({})
    }
    localStorage.clear();
    props.history.push('/');
}

const workItemRoutesWithData = async (url, workItemData, baseUrl = "") => {
    let paramsIncludeData = [{ key: "pki_details", isRetrivable: false, apiParam: "", includeKeys: [] },
    {
        key: "proxyUserDetails", isRetrivable: false, apiParam: "", includeKeys: [
            { key: "ProxyLoginDetails", isRetrivable: true, apiParam: "proxy", includeKeys: ["ApplicantCRN","ApplicantID","ProxyNumber","ProxyIssuerID","InvolvedPartiesSubTypeEnglish","InvolvedPartyID","IsSpecific","NameChangeFlag","ProxyFullName","ProxyID","ProxyUniqueID","ApplicantUserType"] }, //"ProxyID", "ProxyNumber", "InvolvedPartySubTypeID","InvolvedPartyTypeID","NationalityID" 
            { key: "isProxySearchLoaded", isRetrivable: false, apiParam: "" }
        ]
    },
    { key: "applicantUserType", isRetrivable: false, apiParam: "", includeKeys: [] },
    { key: "applicantUserTypeData", isRetrivable: false, apiParam: "", includeKeys: [] },
    { key: "applicantUserID", isRetrivable: false, apiParam: "", includeKeys: [] },
    { key: "resourceDetails", isRetrivable: true, apiParam: "resourceDetails", includeKeys: ["InvolvedPartyID","InvolvedPartiesSubTypeEnglish","InvolvedPartiesSubTypeArabic","InvolvedPartySubTypeID","InvolvedPartyTypeID","NationalityID","IDTypeID"] },
    {
        key: "organizationDetails", isRetrivable: false, apiParam: "", includeKeys: [
            { key: "OrganizationUserDetails", isRetrivable: true, apiParam: "orgRes", includeKeys: ["OrganizationCRNumber", "OrganizationUserCRN","OrganizationSubTypeEnglish","OrganizationUserIDTypeID","OrganizationUserNationalityID"] },
            { key: "OrganizatonDetails", isRetrivable: false, apiParam: "", includeKeys: ["OrganizationCRNumber", "OrganizationEmailID", "OrganizationID", "OrganizationLandLineNumber", "OrganizationName", "OrganizationNameEnglish", "OrganizationSubTypeArabic","OrganizationSubTypeEnglish","OrganizationSubTypeID", "label", "value"] },
            { key: "resourceDetails", isRetrivable: true, apiParam: "resourceDetails", includeKeys: ["InvolvedPartyID","IDTypeID","InvolvedPartiesSubTypeEnglish","InvolvedPartySubTypeID","InvolvedPartyTypeID","NationalityID","InvolvedPartiesSubTypeArabic"] },
            { key: "orgUserType", isRetrivable: false, apiParam: "", includeKeys: [] }
        ]
    },
    { key: "orgUserValidator", isRetrivable: false, apiParam: "", includeKeys: [] },
    { key: "lang", isRetrivable: false, apiParam: "", includeKeys: [] },
    { key: "theme", isRetrivable: false, apiParam: "", includeKeys: [] },
    { key: "font", isRetrivable: false, apiParam: "", includeKeys: [] },
    { key: 'createdUserTypeID', isRetrivable: false, apiParam: "", includeKeys: [] },
    { key: "applicableService", isRetrivable: false, apiParam: "", includeKeys: [] },
    { key: "applicableSubService", isRetrivable: false, apiParam: "", includeKeys: [] },
    { key: "selectedService", isRetrivable: false, apiParam: "", includeKeys: [] },
    { key: "applicantUserTypeData", isRetrivable: false, apiParam: "", includeKeys: [] },
    { key: "profileUserDetails", isRetrivable: false, apiParam: "", includeKeys: [] },
    { key: "isdUser", isRetrivable: true, apiParam: "", includeKeys: ["isdUser"] }
    ]

    let params = store.getState();
    let loginInpuCopy = { "routes": url };
    paramsIncludeData.forEach(function (data, index) {
        if (Object.keys(params[data.key]).length) {
            const retrievedData = getFilteredData(data, params)
            if (retrievedData) {
                loginInpuCopy = { ...loginInpuCopy, ...retrievedData }
            }
        }
    });
    loginInpuCopy = { ...loginInpuCopy, ...workItemData };
    let Base_Url = process.env.REACT_APP_WEB_HOST_REAL_ESTATE //real-estate //slug
    if (baseUrl) {
        Base_Url = baseUrl //real-estate //slug
    }
    if (url.includes("planning-survey") || (workItemData.hasOwnProperty("workItem") && workItemData.workItem.attributes.hasOwnProperty("appName") && workItemData.workItem.attributes.appName === "PS")) {
        Base_Url = process.env.REACT_APP_WEB_HOST_PSN;
    } else if (url.includes("real-estate") || (workItemData.hasOwnProperty("workItem") && workItemData.workItem.attributes.hasOwnProperty("appName") && workItemData.workItem.attributes.appName === "RN")) {
        Base_Url = process.env.REACT_APP_WEB_HOST_REAL_ESTATE;
    } else if (url.includes("land") || (workItemData.hasOwnProperty("workItem") && workItemData.workItem.attributes.hasOwnProperty("appName") && workItemData.workItem.attributes.appName === "LN")) {
        Base_Url = process.env.REACT_APP_WEB_HOST_LAND;
    } else if (url.includes("re-dev") || (workItemData.hasOwnProperty("workItem") && workItemData.workItem.attributes.hasOwnProperty("appName") && workItemData.workItem.attributes.appName === "RD")) {
        Base_Url = process.env.REACT_APP_WEB_HOST_RD;
    }
    else if (url.includes("social-housing") || (workItemData.hasOwnProperty("workItem") && workItemData.workItem.attributes.hasOwnProperty("appName") && workItemData.workItem.attributes.appName === "SH")) {
        // console.log(" (workItemData?.InternalApplicationStatus && (workItemData?.InternalApplicationStatus != '10' || workItemData?.InternalApplicationStatus != 10))", workItemData, (workItemData?.InternalApplicationStatus && (workItemData?.InternalApplicationStatus !== "10" || workItemData?.InternalApplicationStatus !== 10)))
        if (workItemData?.ApplicationStatus && (workItemData?.ApplicationStatus == 1 || workItemData?.ApplicationStatus == "1") && (workItemData?.InternalApplicationStatus && (workItemData?.InternalApplicationStatus !== "10" || workItemData?.InternalApplicationStatus !== 10))) {
            Swal.fire({
                title: "Application is under process"
            });
            return;
        }
        if (workItemData?.workItem?.attributes?.BusinessContext.includes("ServicePayment")) {
            loginInpuCopy = { ...loginInpuCopy, ...{ workItem: workItemData.workItem }, ...{ ViewOnly: "true" }, ...{ NotPaid: "true" } }
        }
        if (workItemData?.workItem?.attributes?.BusinessContext.includes("UpdateApplication")) {
            loginInpuCopy = { ...loginInpuCopy, ...{ workItem: workItemData.workItem }, ...{ ViewOnly: "false" }, ...{ NotPaid: "false" } }
        }
        Base_Url = process.env.REACT_APP_WEB_HOST_SOCIAL_HOUSING;
    }
    else {
        Base_Url = process.env.REACT_APP_WEB_HOST_REAL_ESTATE;
    }

     let path = Base_Url + "domain-redirect/" + btoa(encodeURIComponent(JSON.stringify(loginInpuCopy)))
    //let path =  "http://localhost:3001/land/" + btoa(encodeURIComponent(JSON.stringify(loginInpuCopy)))
    // return;
   window.location = path
}

const workItemRoutes = (url, WorkItemData, baseUrl = "") => {

    // let paramsInclude = ["pki_details", "applicantUserID", "applicantUserType", "resourceDetails", "organizationDetails", "orgUserValidator", "lang", "theme", "proxyUserDetails", "organizationUserDetails", "createdUserTypeID", "selectedService"];
    let paramsIncludeData = [{ key: "pki_details", isRetrivable: false, apiParam: "", includeKeys: [] },
    {
        key: "proxyUserDetails", isRetrivable: false, apiParam: "", includeKeys: [
            { key: "ProxyLoginDetails", isRetrivable: true, apiParam: "proxy", includeKeys: ["ApplicantCRN","ApplicantID","ProxyNumber","ProxyIssuerID","InvolvedPartiesSubTypeEnglish","InvolvedPartyID","IsSpecific","NameChangeFlag","ProxyFullName","ProxyID","ProxyUniqueID","ApplicantUserType"] }, //"ProxyID", "ProxyNumber", "InvolvedPartySubTypeID","InvolvedPartyTypeID","NationalityID" 
            { key: "isProxySearchLoaded", isRetrivable: false, apiParam: "" }
        ]
    },
    { key: "applicantUserType", isRetrivable: false, apiParam: "", includeKeys: [] },
    { key: "applicantUserTypeData", isRetrivable: false, apiParam: "", includeKeys: [] },
    { key: "applicantUserID", isRetrivable: false, apiParam: "", includeKeys: [] },
    { key: "resourceDetails", isRetrivable: true, apiParam: "resourceDetails", includeKeys: ["InvolvedPartyID","InvolvedPartiesSubTypeEnglish","InvolvedPartiesSubTypeArabic","InvolvedPartySubTypeID","InvolvedPartyTypeID","NationalityID","IDTypeID"] },
    {
        key: "organizationDetails", isRetrivable: false, apiParam: "", includeKeys: [
            { key: "OrganizatonDetails", isRetrivable: false, apiParam: "", includeKeys: ["OrganizationCRNumber", "OrganizationID", "OrganizationName", "OrganizationNameEnglish", "OrganizationSubTypeArabic","OrganizationSubTypeEnglish","OrganizationSubTypeID", "label", "value"] },
            { key: "OrganizationUserDetails", isRetrivable: true, apiParam: "orgRes", includeKeys: ["OrganizationCRNumber", "OrganizationUserCRN","OrganizationSubTypeEnglish","OrganizationUserIDTypeID","OrganizationUserNationalityID"] },
            { key: "resourceDetails", isRetrivable: true, apiParam: "resourceDetails", includeKeys: ["InvolvedPartyID","IDTypeID","InvolvedPartiesSubTypeEnglish","InvolvedPartySubTypeID","InvolvedPartyTypeID","NationalityID","InvolvedPartiesSubTypeArabic"] },
            { key: "orgUserType", isRetrivable: false, apiParam: "", includeKeys: [] }
        ]
    },
    { key: "orgUserValidator", isRetrivable: false, apiParam: "", includeKeys: [] },
    { key: "lang", isRetrivable: false, apiParam: "", includeKeys: [] },
    { key: "theme", isRetrivable: false, apiParam: "", includeKeys: [] },
    { key: "font", isRetrivable: false, apiParam: "", includeKeys: [] },
    { key: 'createdUserTypeID', isRetrivable: false, apiParam: "", includeKeys: [] },
    { key: "applicableService", isRetrivable: false, apiParam: "", includeKeys: [] },
    { key: "applicableSubService", isRetrivable: false, apiParam: "", includeKeys: [] },
    // { key: "selectedService", isRetrivable: false, apiParam: "", includeKeys: [] },
    { key: "applicantUserTypeData", isRetrivable: false, apiParam: "", includeKeys: [] },
    { key: "profileUserDetails", isRetrivable: false, apiParam: "", includeKeys: [] },
    { key: "isdUser", isRetrivable: true, apiParam: "", includeKeys: ["isdUser"] }
    ]
    let params = store.getState();
    // let loginInput = { "routes": url };
    let loginInpuCopy = { "routes": url, ...workItemRoutes };
    // Object.keys(params).forEach(function (key) {
    //     if (paramsInclude.includes(key) && Object.keys(params[key]).length) {
    //         loginInput = { ...loginInput, [key]: typeof params[key] === "object" ? { ...params[key] } : params[key] };
    //     }
    // });
    // loginInput = { ...loginInput, ...{ workItemID: WorkItemData.workItem.workItemID, rowData: WorkItemData.workItem.attributes } };

    paramsIncludeData.forEach(function (data, index) {
        if (Object.keys(params[data.key]).length) {
            const retrievedData = getFilteredData(data, params)
            // console.log("retrievedDa",retrievedData)
            if (retrievedData) {
                loginInpuCopy = { ...loginInpuCopy, ...retrievedData }
            }
            // loginInpuCopy = { ...loginInpuCopy, [data.key]: typeof params[data.key] === "object" ? { ...params[data.key] } : params[data.key] };
        }
    });


    // loginInput = { ...loginInput, ...{ workItemID: WorkItemData.workItem.workItemID, workItemType: WorkItemData.workItem.workItemType } };
    if (!(store.getState().sh2_newrequest_details?.ApplicationId === undefined ||
        store.getState().sh2_newrequest_details?.ApplicationId === "")) {
        loginInpuCopy = { ...loginInpuCopy, ...{ workItemID: WorkItemData.workItem.workItemID, workItemType: WorkItemData.workItem.workItemType }, ...{ ApplicationId: store.getState().sh2_newrequest_details.ApplicationId }, ...{ ViewOnly: store.getState().sh2_newrequest_details.ViewOnly }, ...{ NotPaid: store.getState().sh2_newrequest_details.NotPaid } }
    }
    else if (!(store.getState().sh2_newrequest_proxy_details?.ApplicationId === undefined ||
        store.getState().sh2_newrequest_proxy_details?.ApplicationId === "")) {
        loginInpuCopy = { ...loginInpuCopy, ...{ workItemID: WorkItemData.workItem.workItemID, workItemType: WorkItemData.workItem.workItemType }, ...{ ApplicationId: store.getState().sh2_newrequest_proxy_details.ApplicationId }, ...{ ViewOnly: store.getState().sh2_newrequest_proxy_details.ViewOnly }, ...{ NotPaid: store.getState().sh2_newrequest_proxy_details.NotPaid } }
    }
    else {
        loginInpuCopy = { ...loginInpuCopy, ...{ workItemID: WorkItemData.workItem.workItemID, workItemType: WorkItemData.workItem.workItemType } }
    }
    // return btoa(encodeURIComponent(JSON.stringify(loginInput)));
    let Base_Url

    if (url.includes("/e-service/social-housing")) {
        Base_Url = process.env.REACT_APP_WEB_HOST_SOCIAL_HOUSING
    }
    else {
        Base_Url = process.env.REACT_APP_WEB_HOST_REAL_ESTATE
    }


    if (WorkItemData.appName === "LN") {
        Base_Url = process.env.REACT_APP_WEB_HOST_LAND
    } else if (WorkItemData.appName === "PSN") {
        Base_Url = process.env.LAND_TEMPLATE_PATH
    } else if (url.includes("re-dev")) {
        Base_Url = process.env.REACT_APP_WEB_HOST_RD;
    }
    else if (baseUrl) {
        Base_Url = baseUrl //real-estate //slug
    }

    console.log("Base_Url", Base_Url, loginInpuCopy)

    // let path = Base_Url + "domain-redirect/" + btoa(encodeURIComponent(JSON.stringify(loginInput)))
    let path = Base_Url + "domain-redirect/" + btoa(encodeURIComponent(JSON.stringify(loginInpuCopy)))

    window.location = path;
}


const defaultOptions = {
    allowedTags: ['b', 'i', 'em', 'ul', 'li', 'strong', 'a', 'p', 'img', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span'],
    // selfClosing: ['img', 'br', 'hr', 'area', 'base', 'basefont', 'input', 'link', 'meta'],
    allowedAttributes: {
        a: ['href', 'target'],
        '*': ["style"],
        img: ['src'],
    },
    allowedClasses: {
        '*': ['tiles', 'row', 'tile', 'details', 'info', 'project-title', 'title', 'demo-gallery',
            'panel-body', 'bookswrapper', 'bookswrapper', 'book', 'book-img', 'book-info', 'book-title',
            'testimonialSlider', 'testimonial_item', 'img-responsive', 'info-card', 'info-title-row', 'info-download-btn', 'col-md-2',
            'col-md-3', 'specialities', 'box1', 'box2', 'box3', 'box4', 'box5', 'box6', 'heading',
            'slick-list', 'slick-track', 'slide2', 'slick-slide', 'contact-address', 'container', 'slide2',
            'icon-map-pinmoh', 'icon-phonemoh', 'icon-mailmoh', 'd-flex', 'card', 'card-body', 'img-fluid', 'rounded-circle',
            'row', 'd-flex', 'justify-content-center', 'col-lg-4', 'card-header', 'card-title', 'card-text', 'instruction', 'col-lg-8'
        ],
    }

    // allowedIframeHostnames: ['http://localhost:3000/']
};


const isExisty = function (value) {
    return value !== null && value !== undefined;
};

const isEmpty = function (value) {
    if (value instanceof Array) {
        return value.length === 0;
    }
    return value === '' || !isExisty(value);
};

const isEmptyTrimed = function (value) {
    if (typeof value === 'string') {
        return value.trim() === '';
    }
    return true;
};


const currentDate = function (format) {

    var today = new Date();
    var dd = today.getDate();

    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if (dd < 10) {
        dd = '0' + dd;
    }

    if (mm < 10) {
        mm = '0' + mm;
    }

    if (format === "yyyy-mm-dd") {
        today = yyyy + "-" + mm + '-' + dd;
    } else if (format === "yyyy/mm/dd") {
        today = yyyy + "/" + mm + '/' + dd;
    } else if (format === "dd-mm-yyyy") {
        today = dd + '-' + mm + '-' + yyyy;
    }
    // today = mm+'-'+dd+'-'+yyyy;
    // console.log(today);
    // today = mm+'/'+dd+'/'+yyyy;
    // console.log(today);
    // today = dd+'-'+mm+'-'+yyyy;
    // console.log(today);
    // today = dd+'/'+mm+'/'+yyyy;
    // console.log(today);

    return today;

};

const sortAlphabetically = (a, b, key) => {
    console.log()
    if (a[key] < b[key]) { return -1; }
    if (a[key] > b[key]) { return 1; }
    return 0;
}


const convertDateFormat = function (value, format) {

    var d = new Date(value);
    var dd = d.getDate();

    var mm = d.getMonth() + 1;
    var yyyy = d.getFullYear();
    if (dd < 10) {
        dd = '0' + dd;
    }

    if (mm < 10) {
        mm = '0' + mm;
    }

    if (format === "yyyy-mm-dd") {
        d = yyyy + "-" + mm + '-' + dd;
    } else if (format === "yyyy/mm/dd") {
        d = yyyy + "/" + mm + '/' + dd;
    } else if (format === "dd-mm-yyyy") {
        d = dd + '-' + mm + '-' + yyyy;
    } else if (format === "dd/mm/yyyy") {
        d = dd + '/' + mm + '/' + yyyy;
    }
    // today = mm+'-'+dd+'-'+yyyy;
    // console.log(today);
    // today = mm+'/'+dd+'/'+yyyy;
    // console.log(today);
    // today = dd+'-'+mm+'-'+yyyy;
    // console.log(today);
    // today = dd+'/'+mm+'/'+yyyy;
    // console.log(today);

    return d;

};

const fileValidator = (file) => {
    let status = false
    let msg = ""
    // const AllowedFileType = Config.DOCUMENT_UPLOAD_FILE_EXTENTION.split(', ')
    const AllowedFileType = process.env.REACT_APP_FILE_EXT.split(', ')
    const fileSize = parseFloat(file.size / (1024 * 1024)).toFixed(2);
    const fileUploadLimit = process.env.REACT_APP_FILE_UPLOAD_LIMTT
    if (AllowedFileType.includes(file.type)) {
        status = true
        if (parseInt(fileSize) > parseInt(fileUploadLimit)) {
            status = false
            msg = `File Size should not exceed ${fileUploadLimit} mb`
        }
    } else {
        msg = "Please upload valid file";
    }
    return { status, msg }
}

const getUniqueKeyForSecret = () => {
    return new Date().getSeconds().toString() + new Date().getMinutes().toString() + new Date().getHours().toString() + new Date().getDate().toString() + ("0" + (new Date().getMonth() + 1)).slice(-2) + new Date().getFullYear().toString()
    // return new Date().getFullYear().toString() + ("0" + (new Date().getMonth() + 1)).slice(-2) + new Date().getDate().toString()  //new Date().getHours().toString() + new Date().getMinutes().toString() +
}

const getUniqueKeyClientID = () => {
    let timestamp = new Date().getUTCMilliseconds();
    let randomNumber =  Math.floor(Math.random() * (9999999999 - 1000000000 + 1)) + 1000000000;
    return timestamp +new Date().getSeconds().toString() + new Date().getMinutes().toString() + new Date().getHours().toString() + new Date().getDate().toString() + ("0" + (new Date().getMonth() + 1)).slice(-2) + randomNumber;

}



//     const isEmpty =  function(obj) {

//     // Speed up calls to hasOwnProperty
//     var hasOwnProperty = Object.prototype.hasOwnProperty;
//       // null and undefined are "empty"
//       if (obj == null) return true;

//       // Assume if it has a length property with a non-zero value
//       // that that property is correct.
//       if (obj.length > 0)    return false;
//       if (obj.length === 0)  return true;

//       // If it isn't an object at this point
//       // it is empty, but it can't be anything *but* empty
//       // Is it empty?  Depends on your application.
//       if (typeof obj !== "object") return true;

//       // Otherwise, does it have any properties of its own?
//       // Note that this doesn't handle
//       // toString and valueOf enumeration bugs in IE < 9
//       for (var key in obj) {
//           if (hasOwnProperty.call(obj, key)) return false;
//       }

//       return true;
//   };

const findAndReplace = function (string, target, replacement) {
    var i = 0, length = string.length;
    for (i; i < length; i++) {
        string = string.replace(".", "");
        string = string.replace(target, replacement);
    }
    return string;
}

const prefixZeroPad = function (num, size = 2) {
    num = num.toString();
    while (num.length < size) num = "0" + num;
    return num;
}

const updateFormTemplate = (formTemplate, formObjIndex, apiResponse, language) => {
    let formObject = formTemplate.form[formObjIndex].formgroup.input;
    let responseKeys = [Object.keys(apiResponse)];
    let isDataPresent = true;
    formObject.forEach((cur, idx) => {
        let foundFormObj = responseKeys[0].find(current => language === Config.LANG.AR && cur.hasOwnProperty("keyCodeAr") ? cur.keyCodeAr === current : cur.keyCode === current);
        let inputFeild = formTemplate.form[formObjIndex].formgroup.input[idx];
        if (foundFormObj) {
            inputFeild.showAsterisk = false;
            inputFeild.type = "label";
        } else {
            if (isDataPresent) {
                isDataPresent = false
            }
            inputFeild.showAsterisk = true;
            inputFeild.type = "text";
            inputFeild.validator = {
                rules: [
                    "required"
                ],
                errorMsg: [
                    "PLS_FILL_THE_ABOVE_FEILD"
                ]
            }
        }
    });
    return {
        Template: formTemplate,
        isDataPresent: isDataPresent
    };
}

const changeFormInputTypeInToText = (formTemplate, language) => {
    formTemplate.form.forEach((current, index) => {
        let formObject = formTemplate.form[index].formgroup.input;
        formObject.forEach((cur, idx) => {
            formTemplate.form[index].formgroup.input[idx].showAsterisk = true;
            formTemplate.form[index].formgroup.input[idx].type = "text";
            // formTemplate.form[index].formgroup.input[idx].validator = {
            //     rules: [
            //         "required"
            //     ],
            //     errorMsg: [
            //         "PLS_FILL_THE_ABOVE_FEILD"
            //     ]
            // }
        });
    });
    return {
        Template: formTemplate,
        isDataPresent: false
    };
}

const getLookupDataResponse = (config, LookupAPIResponse) => {
    let LookupResponse, requiredString = "";
    if (config?.data) {
        config = config.data;
    }
    let lookupResp = localStorage.getItem("LookupData");
    let storageKey = config?.LookupInput[0]?.LookupType;
    if (config?.LookupInput[0]?.KeyFields) {
        if (Array.isArray(config?.LookupInput[0]?.KeyFields)) {
            for (let cur of config?.LookupInput[0]?.KeyFields) {
                if (requiredString === "") {
                    requiredString = storageKey + "_" + cur.Name + "_" + cur.Value;
                } else {
                    requiredString = requiredString + "_" + cur.Name + "_" + cur.Value;
                }
            }
        } else {
            requiredString = storageKey + "_" + config?.LookupInput[0]?.KeyFields.Name + "_" + config?.LookupInput[0]?.KeyFields.Value;
        }
    } else {
        requiredString = storageKey;
    }
    if (!["", null, undefined].includes(lookupResp)) {
        LookupResponse = { ...JSON.parse(lookupResp), ...LookupAPIResponse }
        let returnData = {};
        if (requiredString && LookupResponse && LookupResponse.hasOwnProperty(requiredString)) {
            returnData = { ...LookupResponse[requiredString] };
            return { returnData: returnData, requiredString: requiredString, LookupResponse: LookupResponse, isPresent: true };
        } else {
            return { requiredString: requiredString, LookupResponse: LookupResponse, isPresent: false };
        }
    } else {
        return { requiredString: requiredString, isPresent: false };
    }
}

const setLookupDataResponse = (requiredString, decrypted, LookupAPIResponse) => {
    if (!LookupAPIResponse.hasOwnProperty(requiredString)) {
        return { ...LookupAPIResponse, [requiredString]: { ...decrypted } };
    } else if (LookupAPIResponse.hasOwnProperty(requiredString)) {
        return { ...LookupAPIResponse };
    }
}

const setStorageWithExpiry = (key, value, ttl) => {
    try {
        const now = new Date()
        const item = {
            ...value,
            expiry: now.getTime() + ttl,
        }
        localStorage.setItem(key, JSON.stringify(item))
    } catch (error) {
        console.log("MOH ~ error:", error)
    }

}

const clearStorageExpired = (key) => {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) {
        return null
    }
    const item = JSON.parse(itemStr)
    const now = new Date()
    if (now.getTime() > item.expiry) {
        localStorage.removeItem(key)
        return null
    }
    return item
}

const setCookieWithExpiry = () => {
    try {
        let cookie_value = getUniqueKeyClientID();
        document.cookie = `client_id=${cookie_value}; expires=${new Date(new Date().getTime()+1000*60*60*24*365).toGMTString()}; path=/`;

    } catch (error) {
        console.log("MOH ~ error:", error)
    }

}

const getLookUpList = async (lookUpName, template, formObjIndex, formInputIndex, idKeyName, englishKeyName, arabicKeyName, language) => {

    let inpuField = template.form[formObjIndex].formgroup.input[formInputIndex];
    inpuField.showAsterisk = true;
    inpuField.type = "select";
    inpuField.validator = {
        rules: [
            "required"
        ],
        errorMsg: [
            "PLS_CHOOSE_ANY_ONE_OPTION"
        ]
    }

    let postData = {
        "LookupInput": [
            {
                "LookupType": lookUpName
            }
        ]
    }

    try {
        let response = await createAPIRequest("POST", Config.GET_UTILITY_LOOKUP, postData);
        if (response) {
            let lookUpFeilds = response.LookupDataFields;
            let list = [];
            lookUpFeilds.forEach((val, idx) => {
                list[idx] = { text: language === Config.LANG.AR ? lookUpFeilds[idx][arabicKeyName] : lookUpFeilds[idx][englishKeyName], value: lookUpFeilds[idx][idKeyName], selected: false };
            });
            inpuField.options = list;
            return {
                Template: template
            }
        } else {
            inpuField.options = [];
            return {
                Template: template
            }
        }
    } catch (error) {
        logErrorAPI(error);
    }
}

const sanitize = (dirty, option) => {

    const options = { ...defaultOptions, ...option };

    return sanitizeHtml(
        dirty,
        options
    )
};


const getLoginString = (storeDetails) => {
    /**
     * BUG NO Code fix for defect : MOH-3817
     * Date : 2021/03/18
     * Change Done by : Amol
     * Comment : Added proxyUserDetails in paramsInclude to get proxy details.
     * Reviewd by: Prakash kumar S
     * 
     * 
     * Start
     */
    let paramsInclude = ["pki_details", "applicantUserID", "applicantUserType", "createdUserTypeID", "applicantUserTypeData", "resourceDetails", "organizationDetails", "orgUserValidator", "lang", "proxyUserDetails", "userList", "organizationUserDetails", "isdUser"]
    /** End */
    let params = storeDetails;
    let loginInput = [];
    Object.keys(params).forEach(function (key) {
        if (paramsInclude.includes(key) && Object.keys(params[key]).length) {
            loginInput = { ...loginInput, [key]: typeof params[key] === "object" ? { ...params[key] } : params[key] };
        }
    });
    return btoa(encodeURIComponent(JSON.stringify(loginInput)));
}

const convertJSONToEncodedString = (JSON) => {
    return btoa(JSON)
}

const convertEncodedStringToJSON = (encodedString) => {
    return atob(encodedString)
}


var JsonFormatter = {
    stringify: function (cipherParams) {

        // console.log('cipherParams', cipherParams);

        // create json object with ciphertext
        var jsonObj = { ct: cipherParams.ciphertext.toString(CryptoJS.enc.Hex) };

        // optionally add iv or salt
        if (cipherParams.iv) {
            jsonObj.iv = cipherParams.iv.toString();
        }

        if (cipherParams.salt) {
            jsonObj.s = cipherParams.salt.toString();
        }

        // stringify json object
        return JSON.stringify(jsonObj);
    },
    parse: function (jsonStr) {
        // parse json string
        var jsonObj = JSON.parse(jsonStr);

        // extract ciphertext from json object, and create cipher params object
        var cipherParams = CryptoJS.lib.CipherParams.create({
            ciphertext: CryptoJS.enc.Hex.parse(jsonObj.ct)
        });

        // optionally extract iv or salt

        if (jsonObj.iv) {
            cipherParams.iv = CryptoJS.enc.Hex.parse(jsonObj.iv);
        }

        if (jsonObj.s) {
            cipherParams.salt = CryptoJS.enc.Hex.parse(jsonObj.s);
        }

        if (jsonObj.auth) {
            cipherParams.auth = CryptoJS.enc.Hex.parse(jsonObj.auth);
        }

        // console.log('cipherParams', cipherParams)

        return cipherParams;
    }
};



const cmsEncryptHeaderAuthKey = (string) => {


    const UniqueKey =  getActionHelperCode(process.env.REACT_APP_ACTION_HELPER);

    // Encrypt 
    var ciphertext = CryptoJS.AES.encrypt(JSON.stringify(string), UniqueKey, {
        format: JsonFormatter
    });

    const parsedJSON = JSON.parse(ciphertext);

    // parsedJSON['auth'] = UniqueKey

    const stringifiedJSON = JSON.stringify(parsedJSON)

    return stringifiedJSON.toString();

}

const cmsDecryptHeaderAuthKey = (ciphertext) => {


    const secret = getActionHelperCode(process.env.REACT_APP_ACTION_HELPER);
    // const secret = JSON.parse(ciphertext).auth;

    // Decrypt
    var bytes = CryptoJS.AES.decrypt(ciphertext, secret, {
        // iv: CryptoJS.enc.Hex.stringify('485465232ee3e811335ee4517e59a210'),
        // s: CryptoJS.enc.Hex.stringify('563087ebca3a8d8b'),
        format: JsonFormatter
    });
    return bytes.toString(CryptoJS.enc.Utf8); // originalText
}



const bwEncryptHeaderAuthKey = (string) => {


    const unique = getActionHelperCode(process.env.REACT_APP_ACTION_HELPER_BW);

    // Encrypt 
    var ciphertext = CryptoJS.AES.encrypt(JSON.stringify(string), unique, {
        format: JsonFormatter
    });

    const parsedJSON = JSON.parse(ciphertext);

    // parsedJSON['auth'] = unique;

    const stringifiedJSON = JSON.stringify(parsedJSON)

    return stringifiedJSON.toString();

}

const bwDecryptHeaderAuthKey = (ciphertext) => {

    const unique = getActionHelperCode(process.env.REACT_APP_ACTION_HELPER_BW);
    // Decrypt
    var bytes = CryptoJS.AES.decrypt(ciphertext, unique, {
        format: JsonFormatter
    });
    return bytes.toString(CryptoJS.enc.Utf8); // originalText
}



const urlBuilderEncryptParam = (baseUrl, param) => {
    let queryString = btoa(bwEncryptHeaderAuthKey(param))
    return window.location.hostname + ":" + window.location.port + "/" + baseUrl + "?param=" + queryString;
}

const getDecryptQueryParam = (param) => {
    return JSON.parse(bwDecryptHeaderAuthKey(atob(param)));
}


const encryptHeaderAuthKey = (string) => {
    // Encrypt
    // console.log("tst", string, typeof string);
    const unique = getActionHelperCode(process.env.REACT_APP_ACTION_HELPER_BW);
    var ciphertext = CryptoJS.AES.encrypt(string, unique, {
        mode: CryptoJS.mode.CBC,
        adding: CryptoJS.pad.Pkcs7
    }).toString();
    // console.log("helper cipher enc", ciphertext);
    return ciphertext;

}

const decryptHeaderAuthKey = (ciphertext) => {
    const unique = getActionHelperCode(process.env.REACT_APP_ACTION_HELPER_BW);
    // Decrypt
    var bytes = CryptoJS.AES.decrypt(ciphertext, unique);
    return bytes.toString(CryptoJS.enc.Utf8); // originalText
}

const cSharpEncryptHeaderAuthKey = (string) => {
    var key = CryptoJS.enc.Utf8.parse(getActionHelperCode(process.env.REACT_APP_ACTION_HELPER_C)); var iv = CryptoJS.enc.Utf8.parse('8080808080808080'); var ciphertext = CryptoJS.AES.encrypt(JSON.stringify(string), key, {
        mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7,
        iv: iv,
    }); return ciphertext.toString()
}

const cSharpDecryptHeaderAuthKey = (ciphertext) => {
    var key = CryptoJS.enc.Utf8.parse(getActionHelperCode(process.env.REACT_APP_ACTION_HELPER_C)); var iv = CryptoJS.enc.Utf8.parse('8080808080808080');
    var bytes = CryptoJS.AES.decrypt(ciphertext, key, {
        mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7,
        iv
    });
    return bytes.toString(CryptoJS.enc.Utf8); // originalText
}

function appendZeroToLength(value, length) {
    return `${value}`.padStart(length, 0);
}

function decryptMulkiaParams(ciphertext) {
    //let encryptedCipherText = "G7VWVAGdfrve6KEatRN3gsMbndYnw7HAGX$$$$IKV2oBnEdU+2MQrqruIIvrCshSc5X";
    let encryptedCipherText = ciphertext.replaceAll("$$$$", "/");
    let secretKey = getSecretKey("bXVsa2lhLnFyQ29kZUBtb2gxMjM=");
    let decryptedData = CryptoJS.AES.decrypt(encryptedCipherText, secretKey, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    return JSON.parse(decryptedData.toString(CryptoJS.enc.Utf8));
}

const getSecretKey = (key) => {
    let secSpec = CryptoJS.enc.Utf8.parse(atob(key));
    secSpec = CryptoJS.lib.WordArray.create(secSpec.words.slice(0, 16 / 4));
    return secSpec;
}

const getDateAsText = () => {
    const now = new Date();
    const nowText = appendZeroToLength(now.getUTCFullYear(), 4) + '.'
        + appendZeroToLength(now.getUTCMonth() + 1, 2) + '.'
        + appendZeroToLength(now.getUTCDate(), 2) + ', '
        + appendZeroToLength(now.getUTCHours(), 2) + ':'
        + appendZeroToLength(now.getUTCMinutes(), 2) + ':'
        + appendZeroToLength(now.getUTCSeconds(), 2) + '.'
        + appendZeroToLength(now.getUTCMilliseconds(), 4) + ' UTC';
    return nowText;
}

// CMS calls encryption 

// var JsonFormatter = {
//     stringify: function (cipherParams) {
//         // create json object with ciphertext
//         var jsonObj = { ct: cipherParams.ciphertext.toString(CryptoJS.enc.Hex) };

//         // optionally add iv or salt
//         if (cipherParams.iv) {
//             jsonObj.iv = cipherParams.iv.toString();
//         }

//         if (cipherParams.salt) {
//             jsonObj.s = cipherParams.salt.toString();
//         }

//         // stringify json object
//         return JSON.stringify(jsonObj);
//     },
//     parse: function (jsonStr) {
//         // parse json string
//         var jsonObj = JSON.parse(jsonStr);

//         // extract ciphertext from json object, and create cipher params object
//         var cipherParams = CryptoJS.lib.CipherParams.create({
//             ciphertext: CryptoJS.enc.Hex.parse(jsonObj.ct)
//         });

//         // optionally extract iv or salt

//         if (jsonObj.iv) {
//             cipherParams.iv = CryptoJS.enc.Hex.parse(jsonObj.iv);
//         }

//         if (jsonObj.s) {
//             cipherParams.salt = CryptoJS.enc.Hex.parse(jsonObj.s);
//         }


//         // console.log('cipherParams', cipherParams)

//         return cipherParams;
//     }
// };


/*
    Encryption Method : AES
    Method : CTR
    */
const encryptRequestBody = (requestParams) => {
    // An example 128-bit key (16 bytes * 8 bits/byte = 128 bits)
    var key = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16];

    // Convert text to bytes
    var text = JSON.stringify(requestParams);
    var textBytes = aesjs.utils.utf8.toBytes(text);

    // The counter is optional, and if omitted will begin at 1
    var aesCtr = new aesjs.ModeOfOperation.ctr(key, new aesjs.Counter(5));
    var encryptedBytes = aesCtr.encrypt(textBytes);

    // To print or store the binary data, you may convert it to hex
    var encryptedHex = aesjs.utils.hex.fromBytes(encryptedBytes);
    // console.log("encrypt", encryptedHex);
    return encryptedHex;
}

const decryptRequestBody = (responseDataEncHex) => {
    // An example 128-bit key (16 bytes * 8 bits/byte = 128 bits)
    var key = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16];
    // When ready to decrypt the hex string, convert it back to bytes
    var encryptedBytes = aesjs.utils.hex.toBytes(responseDataEncHex);

    // The counter mode of operation maintains internal state, so to
    // decrypt a new instance must be instantiated.
    var aesCtr = new aesjs.ModeOfOperation.ctr(key, new aesjs.Counter(5));
    var decryptedBytes = aesCtr.decrypt(encryptedBytes);

    // Convert our bytes back into text
    var decryptedText = aesjs.utils.utf8.fromBytes(decryptedBytes);
    //    console.log("encrypt - decrypt", decryptedText);
    return decryptedText;
}

const WizardBreadCrumbObj = (ServiceName) => {
    let BreadObj = [
        { TITLE: translateLabel("HOME"), URI: Config.BREADCRUMBS_URI["HOME"] },
        { TITLE: store.getState().lang.lang === Config.LANG.AR ? ServiceName.serviceValue.ServiceNameArabic : ServiceName.serviceValue.ServiceNameEnglish, URI: "" }
    ];
    return BreadObj;
}

const CreatedUserDetails = () => {
    let createdUserID = store.getState().orgUserValidator.hasOwnProperty("OrgUserType") && store.getState().organizationDetails.hasOwnProperty("resourceDetails") ? store.getState().organizationDetails.resourceDetails.InvolvedPartyID : store.getState().organizationDetails.hasOwnProperty("OrganizationUserDetails") && !store.getState().organizationDetails.OrganizationUserDetails.hasOwnProperty("OrganizationSubTypeID") ? store.getState().organizationDetails.OrganizationUserDetails.OrganizationUserID : store.getState().proxyUserDetails.hasOwnProperty("ProxyLoginDetails") ? store.getState().proxyUserDetails.ProxyLoginDetails.ProxyID : store.getState().resourceDetails.InvolvedPartyID;
    return {
        CreatedUserID: createdUserID
    }
}

const ActionUserDetails = () => {
    let actionUserID = store.getState().organizationDetails.hasOwnProperty("OrganizationUserDetails") && !store.getState().organizationDetails.OrganizationUserDetails.hasOwnProperty("OrganizationSubTypeID") ? store.getState().organizationDetails.OrganizationUserDetails.OrganizationUserID : store.getState().proxyUserDetails.hasOwnProperty("ProxyLoginDetails") ? store.getState().proxyUserDetails.ProxyLoginDetails.ApplicantID : store.getState().resourceDetails.InvolvedPartyID;
    return {
        ActionUserID: actionUserID
    }
}

const OwnerDetails = () => {
    let InvolvedPartyID = store.getState().organizationDetails.hasOwnProperty("OrganizationUserDetails") && !store.getState().organizationDetails.hasOwnProperty("resourceDetails") ? store.getState().organizationDetails.OrganizationUserDetails.OrganizationID : store.getState().proxyUserDetails.hasOwnProperty("ProxyLoginDetails") ? store.getState().proxyUserDetails.ProxyLoginDetails.ApplicantID : store.getState().resourceDetails.InvolvedPartyID;
    let InvolvedPartyTypeID = store.getState().organizationDetails.hasOwnProperty("OrganizationUserDetails") && !store.getState().organizationDetails.hasOwnProperty("resourceDetails") ? store.getState().resourceDetails.InvolvedPartyTypeID : store.getState().proxyUserDetails.hasOwnProperty("ProxyLoginDetails") ? store.getState().applicantUserTypeData.InvolvedPartyTypeID : store.getState().resourceDetails.InvolvedPartyTypeID;
    let NationalityID = store.getState().organizationDetails.hasOwnProperty("OrganizationUserDetails") && !store.getState().organizationDetails.hasOwnProperty("resourceDetails") ? Config.RN1_APPLICATION_REQUEST.OmanNationalityID : store.getState().proxyUserDetails.hasOwnProperty("ProxyLoginDetails") ? store.getState().pki_details.pkiSimCardDetails.NationalityID : store.getState().resourceDetails.NationalityID;
    let IDTypeID = store.getState().organizationDetails.hasOwnProperty("OrganizationUserDetails") && !store.getState().organizationDetails.hasOwnProperty("resourceDetails") ? Config.ID_TYPE_ID.CRNumber : store.getState().proxyUserDetails.hasOwnProperty("ProxyLoginDetails") ? store.getState().pki_details.pkiSimCardDetails.IDTypeID : store.getState().pki_details.pkiSimCardDetails.IDTypeID;
    let InvolvedPartySubTypeID = store.getState().organizationDetails.hasOwnProperty("OrganizationUserDetails") && !store.getState().organizationDetails.hasOwnProperty("resourceDetails") ? store.getState().organizationDetails.OrganizationUserDetails.OrganizationSubTypeID : store.getState().proxyUserDetails.hasOwnProperty("ProxyLoginDetails") ? store.getState().applicantUserTypeData.InvolvedPartySubTypeID : store.getState().resourceDetails.InvolvedPartySubTypeID;
    return {
        InvolvedPartyID: InvolvedPartyID,
        InvolvedPartyTypeID: InvolvedPartyTypeID,
        NationalityID: NationalityID,
        IDTypeID: IDTypeID,
        InvolvedPartySubTypeID: InvolvedPartySubTypeID
    }
}

const ExistingApplicationURLParams = () => {
    let callBackParam = {
        SessionID: store.getState().pki_details.SessionID,
        InvolvedPartyID: store.getState().resourceDetails.InvolvedPartyID,
        InvolvedPartyTypeID: store.getState().resourceDetails.InvolvedPartyTypeID
    }
    let encryptParams = btoa(Utils.bwEncryptHeaderAuthKey(callBackParam));
    return encryptParams;
}

const notReleasedService = (title) => {
    Swal.fire({
        title: translateLabel('Info'),
        text: translateLabel("SERVICE_UNDER_DEVELOPEMT"),
        icon: 'info',
        confirmButtonColor: '#470BFF',
        confirmButtonText: translateLabel('OK')
    });
}

const notAvailableService = () => {

    Swal.fire({
        text: translateLabel("ServiceNotAvailable"),
        icon: 'warning',
        iconHtml: "<i className='icon-danger1moh' style='font-size:50px'>!</i>",
        confirmButtonColor: '#4300e2',
        confirmButtonText: translateLabel("OK")
    }).then((result) => {

    });
}

const TemporarilyAvailableService = () => {
    Swal.fire({
        text: translateLabel("THIS_SERVICE_IS_TEMPORARILY_UNAVAILABLE"),
        icon: 'warning',
        iconHtml: "<i className='icon-danger1moh' style='font-size:50px'>!</i>",
        confirmButtonColor: '#4300e2',
        confirmButtonText: translateLabel("OK")
    }).then((result) => {
    });
}

const MaintainencePageServices = () => {
    Swal.fire({
        title: translateLabel('SORRY_FOR_INCONVENIENCE'),
        text: translateLabel("MAINTAINENCE_PAGE_TEXT"),
        icon: 'info',
        confirmButtonColor: '#470BFF',
        confirmButtonText: translateLabel('OK')
    });
}

const getUniqueTranscationID = () => {
    return new Date().getFullYear().toString() + new Date().getHours().toString() + new Date().getMinutes().toString() + new Date().getSeconds().toString() + new Date().getDate().toString();
}

const LookupCache = () => {
    //console.log("MOH ~ WorkListCache:")
    let requestData = [
        {
            "LookupInput": [{
                "LookupType": "ServiceSubService",
            }]
        },
        {
            "LookupInput": [{
                "LookupType": "ApplicationStatus",
            }]
        },
        {
            "LookupInput": [{
                "LookupType": "Service",
            }]
        }
    ]
    let queryString, postQueryEncrypt;
    let param;
    let pathArr = requestData.map((element) => {
        if (store.getState().lang.lang !== Config.LANG.AR) {
            queryString = "SortBy=" + Config.RN1_APPLICATION_REQUEST.EnglishLookup;
            param = btoa(Utils.bwEncryptHeaderAuthKey(queryString));
            if (queryString !== "") {
                postQueryEncrypt = "?param=" + param.replace(/"/g, "");
            }
            return { url: Config.GET_UTILITY_LOOKUP + postQueryEncrypt, postData: btoa(Utils.bwEncryptHeaderAuthKey(element)), unEncryptedData: element };
        } else {
            queryString = "SortBy=" + Config.RN1_APPLICATION_REQUEST.ArabicLookup;
            param = btoa(Utils.bwEncryptHeaderAuthKey(queryString));
            if (queryString !== "") {
                postQueryEncrypt = "?param=" + param.replace(/"/g, "");
            }
            return { url: Config.GET_UTILITY_LOOKUP + postQueryEncrypt, postData: btoa(Utils.bwEncryptHeaderAuthKey(element)), unEncryptedData: element };
        }
    });
    let LookupFields;
    let finalAPIUrl = [];
    let LookupAPIResponse = {};
    for (let cur of pathArr) {
        LookupFields = getLookupDataResponse(cur.unEncryptedData, {});
        if (LookupFields.hasOwnProperty("LookupResponse")) {
            LookupAPIResponse = { ...LookupFields.LookupResponse }
        }
        if (LookupFields.hasOwnProperty("isPresent") && LookupFields.isPresent === false) {
            finalAPIUrl.push(cur)
        }
    }
    if (finalAPIUrl.length > 0) {
        axios.all(finalAPIUrl.map(arr => axios.post(arr.url, arr.postData, {
            headers: {
                'accept': 'application/json',
                'content-type': 'application/json',
            }
        }))).then(responseArr => {
            for (let respVal of responseArr) {
                let storageData = respVal.config?.data;
                let decrpyptData = bwDecryptHeaderAuthKey(atob(storageData));
                let storageDecryptData = JSON.parse(decrpyptData);
                let requiredString = storageDecryptData?.LookupInput[0]?.LookupType;
                let finalResponse = setLookupDataResponse(requiredString, JSON.parse(bwDecryptHeaderAuthKey(atob(respVal.data))), LookupAPIResponse)
                LookupAPIResponse = { ...finalResponse };
                setStorageWithExpiry("LookupData", finalResponse, Number(Config.MODULE_CONFIG.DYNA_STORE_EXPIRY));
            }
        }).catch(err => {
            console.log("MOH ~ err:", err)
        })
    }
}

const getRequiredLookupResponse = (filterData) => {
    if (store.getState().staticData?.[filterData.LookupName]?.[filterData.Value]) {
        return store.getState().staticData[filterData.LookupName][filterData.Value];
    } else {
        let lookupData = JSON.parse(localStorage.getItem("LookupData"));
        if (lookupData.hasOwnProperty(filterData.LookupName)) {
            return lookupData[filterData.LookupName]["LookupDataFields"].find(cur => cur.hasOwnProperty(filterData.UniqueField) && cur[filterData.UniqueField] === filterData.Value)
        }
    }

}

const getMOCIData = async (CompanyCRNumber) => {
    try {
        const loggedInUserCRN = store.getState().pki_details?.CivilNumber
        const requestData = {
            OperationName: "CompanyOverviewRequest",
            CRNumber: CompanyCRNumber
        }
        const path = Config.GET_MOCI_DETAILS;
        const companyResponse = await createAPIRequest("POST", path, requestData, {});
        if (companyResponse) {
            console.log(companyResponse);
            if (companyResponse?.companyOverviewResponse?.wsResponseBody) {
                if (companyResponse?.companyOverviewResponse?.wsResponseBody?.companyOverview?.isExpired && companyResponse?.companyOverviewResponse?.wsResponseBody?.companyOverview?.isExpired !== 'YES') {
                    let foundUser = undefined;
                    if (companyResponse?.companyOverviewResponse?.wsResponseBody?.companyOverview?.investors?.investor && foundUser === undefined) {
                        foundUser = companyResponse?.companyOverviewResponse?.wsResponseBody?.companyOverview?.investors?.investor?.find((investor) => investor?.person?.idNumber === loggedInUserCRN)
                    }
                    if (companyResponse?.companyOverviewResponse?.wsResponseBody?.companyOverview?.signatories?.signatory && foundUser === undefined) {
                        foundUser = companyResponse?.companyOverviewResponse?.wsResponseBody?.companyOverview?.signatories?.signatory?.find((signatory) => signatory?.idNumber === loggedInUserCRN)
                    }
                    if (foundUser) {
                        return companyResponse?.companyOverviewResponse?.wsResponseBody;
                    }
                    else {
                        WarningAlert('LOGIN_UNAUTH');
                    }
                }
                else {
                    WarningAlert('Company_Expired');
                }
            } else {
                NoRecFoundAlert()
            }
        } else {
            NoRecFoundAlert()
        }
    }
    catch (error) {
        console.error(error);
    }
}


const Utils = {
    currentDate,
    isExisty,
    isEmpty,
    isEmptyTrimed,
    convertDateFormat,
    findAndReplace,
    fileValidator,
    prefixZeroPad,
    updateFormTemplate,
    changeFormInputTypeInToText,
    getLookUpList,
    getLoginString,
    convertJSONToEncodedString,
    convertEncodedStringToJSON,
    encryptHeaderAuthKey,
    decryptHeaderAuthKey,
    encryptRequestBody,
    decryptRequestBody,
    cmsEncryptHeaderAuthKey,
    cmsDecryptHeaderAuthKey,
    bwEncryptHeaderAuthKey,
    bwDecryptHeaderAuthKey,
    decryptMulkiaParams,
    sanitize,
    getDateAsText,
    redirectWithReductData,
    workItemRoutesWithData,
    workItemRoutes,
    logoutAccordingToRole,
    logoutPostOfficeVisitor,
    getPdfPath,
    notReleasedService,
    logoutFlushStore,
    CreatedUserDetails,
    ActionUserDetails,
    sortAlphabetically,
    WizardBreadCrumbObj,
    OwnerDetails,
    ExistingApplicationURLParams,
    cSharpEncryptHeaderAuthKey,
    cSharpDecryptHeaderAuthKey,
    getUniqueTranscationID,
    urlBuilderEncryptParam,
    getDecryptQueryParam,
    getLookupDataResponse,
    setLookupDataResponse,
    setStorageWithExpiry,
    clearStorageExpired,
    getRequiredLookupResponse,
    LookupCache,
    notAvailableService,
    TemporarilyAvailableService,
    MaintainencePageServices,
    getMOCIData,
    getUniqueKeyForSecret,
    setCookieWithExpiry,
    getUniqueKeyClientID,
    getEncryptActionCode,
    getActionHelperCode
}


export default Utils;

